var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0.625V3.625M10.375 0.625V3.625M14.125 9.625V3.625C14.125 3.22718 13.967 2.84564 13.6857 2.56434C13.4044 2.28304 13.0228 2.125 12.625 2.125H2.125C1.72718 2.125 1.34564 2.28304 1.06434 2.56434C0.783035 2.84564 0.625 3.22718 0.625 3.625V14.125C0.625 14.5228 0.783035 14.9044 1.06434 15.1857C1.34564 15.467 1.72718 15.625 2.125 15.625H8.125M0.625 6.625H14.125M10.375 14.125L11.875 15.625L14.875 12.625",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.58b233b73e4ff305823e500136e1e300.svg";
export { ForwardRef as ReactComponent };